import { IIdObject } from '@common/interfaces/id-object.interface';
import { IExclusion } from '../item-generated-api';

export interface IExclusionDto extends IExclusion, IIdObject {
    label: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createExclusionDto = (item: IExclusion): IExclusionDto => {
    return {
        ...item,
        id: `${item.product_code}/${item.product_name}`,
        label: `${item.product_name}`,
    };
};
